// Soft UI Dashboard PRO React Base Styles

import colors from 'shared/theme/base/colors';

const { transparent } = colors;

export default {
  styleOverrides: {},
};
